import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';
import WordSketchTab from './WordSketchTab.js'
import { Tooltip2, Classes } from '@blueprintjs/popover2';

class WordSketch extends React.PureComponent {

  state = {
    selectedTabId:"Global"
  }
  handleTabChange = (navbarTabId) => this.setState({ selectedTabId: navbarTabId });


  render() {
      const { ws, wsByReal, t, subCorpora } = this.props;
      var selectedTabId=this.state.selectedTabId;

      const tabs = [];

        const wsTab = <WordSketchTab 
                          ws={ws['_global_']}
                          wsByReal={wsByReal} 
                          sessionId={this.props.sessionId} 
                          query={this.props.query}
                          performSearch={this.props.performSearch}
                          concordSampling={this.props.concordSampling}
                          csvDelimiter={this.props.csvDelimiter}
                      />;
        const tab = <Tab key='Global' id='Global' title={t('global')} panel={wsTab} />;
        tabs.push(tab);
      //}

      // generate the indidual stat pages (sub-corpus or partition)
      if (Object.keys(ws).length > 2) {
        const displayName=Object.keys(ws).length>16;

        for (var i=0;i<subCorpora.length;i++) {
          const subCorpus=subCorpora[i];
          if (subCorpus!=='_global_' && ws[subCorpus]) {
            const title=(displayName) ? (" "+(i+1).toString()).slice(-2):subCorpus;
            const wsTab = <WordSketchTab 
                              name={subCorpus}
                              displayName={displayName}
                              ws={ws[subCorpus]}
                              wsByReal={null} 
                              sessionId={this.props.sessionId} 
                              query={this.props.query}
                              performSearch={this.props.performSearch}
                              concordSampling={this.props.concordSampling}
                              csvDelimiter={this.props.csvDelimiter}
                          />;
            const tab = <Tab key={subCorpus} id={subCorpus} title={title} panel={wsTab} >
                          {displayName && <Tooltip2 content={subCorpus} className={Classes.TOOLTIP2_INDICATOR} placement="bottom" >…</Tooltip2>}
                       </Tab>;
            tabs.push(tab);
            if (Object.keys(ws).length === 2) {
              selectedTabId=subCorpus;
            }
          }
        }
      }

      return (
        <>
          {/* <H4>{t('query')}: <span style={{"color":"#106ba3"}}>{this.props.query}</span></H4> */}
          <Tabs onChange={this.handleTabChange} selectedTabId={selectedTabId} renderActiveTabPanelOnly >
            { tabs.length > 0 && 
              tabs
            }
            {
              tabs.length === 0 &&
              <div>
                <br/>
                {t('noWorsketchBeyondTheLoglikeThreshold')}
              </div>
            }
          </Tabs>

        </>
      );
  }
}

WordSketch.propTypes = {
  subCorpora : PropTypes.array,  
  // see prepCoocData for an example
  ws: PropTypes.object,
  wsByReal: PropTypes.object,
  query: PropTypes.string,
  sessionId: PropTypes.string,
  performSearch: PropTypes.func,
  concordSampling: PropTypes.bool,  
  csvDelimiter: PropTypes.string,
};

export default withTranslation()(WordSketch);